// Thư mục: src/services/xangDauService.js
import api from "@/api";

const BASE_URL = "/api/xang-dau";

/**
 * API service cho Quản lý Xăng Dầu
 */
export const XangDauApi = {
  // === API CHO TÀI XẾ ===
  /**
   * Tài xế nộp báo cáo đổ xăng
   * @param {object} payload - XangDauLogRequest
   * @returns {Promise<object>} XangDauLogResponse
   */
  createLog(payload) {
    return api.post(BASE_URL, payload).then((res) => res.data);
  },

  // === API CHO ADMIN/KẾ TOÁN ===

  adminCreate(payload) {
    return api
      .post(`${BASE_URL}/admin-create`, payload)
      .then((res) => res.data);
  },

  getTonDau(xeId, denNgay) {
    const params = {};
    if (denNgay) params.denNgay = denNgay; // 'yyyy-MM-dd'
    return api
      .get(`/api/xang-dau/ton-dau/${xeId}`, { params })
      .then((res) => res.data);
  },

  upsertTonDau(payload) {
    return api.post(`${BASE_URL}/ton-dau`, payload).then((res) => res.data);
  },
  /**
   * Admin xem danh sách log (lọc + phân trang)
   * @param {object} params - { xeId?, tuNgay?, denNgay?, trangThai?, page?, size?, sort? }
   */
  listLogs(params) {
    return api.get(`${BASE_URL}/list`, { params }).then((res) => res.data);
  },

  /**
   * Admin duyệt 1 log
   */
  approve(logId) {
    return api.post(`${BASE_URL}/${logId}/approve`).then((res) => res.data);
  },

  markAsPaid(id, payload) {
    return api
      .post(`/api/xang-dau/${id}/thanh-toan`, payload)
      .then((res) => res.data);
  },

  /**
   * Admin từ chối 1 log
   * @param {number} logId
   * @param {string} lyDo
   */
  reject(logId, lyDo) {
    return api
      .post(`${BASE_URL}/${logId}/reject`, null, { params: { lyDo } })
      .then((res) => res.data);
  },

  /**
   * Lấy chi tiết 1 log
   */
  getById(logId) {
    return api.get(`${BASE_URL}/${logId}`).then((res) => res.data);
  },

  correctLog(id, data) {
    return api
      .patch(`/api/xang-dau/${id}/chinh-sua`, data)
      .then((res) => res.data);
  },

  uploadEditEvidence(files) {
    const form = new FormData();
    files.forEach((f) => form.append("files", f));
    return api
      .post(`/api/xang-dau/upload-edit-evidence`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data); // -> trả về mảng URL
  },

  getEditHistory(logId) {
    return api
      .get(`/api/xang-dau/${logId}/lich-su-chinh-sua`)
      .then((res) => res.data);
  },

  getCauFuelSummary(params) {
    // params: { xeId, tuNgay?, denNgay? }
    return api
      .get("/api/admin/cau/fuel-summary", { params })
      .then((res) => res.data);
  },

  // ⭐ THÊM: Danh sách phiên cẩu của 1 xe trong khoảng ngày (để xem + xuất Excel)
  listCauByXe(params) {
    // params: { xeId, tuNgay?, denNgay? }
    return api.get("/api/admin/cau/by-xe", { params }).then((res) => res.data);
  },
};

export const XeOptionsApi = {
  listForSelect() {
    return api.get("/api/xe/options").then((res) => res.data);
  },
};

export const TaiXeOptionsApi = {
  listForSelect() {
    return api
      .get("/api/nguoi-dung/by-chuc-vu-code/TAI_XE")
      .then((res) => res.data);
  },
};
